import { render, staticRenderFns } from "./VyungLoyalty.vue?vue&type=template&id=005d7635&"
import script from "./VyungLoyalty.vue?vue&type=script&lang=js&"
export * from "./VyungLoyalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports